import { apiRequest } from './client'

export type ClientUiWireOptionValue = {
  value: string
}

export type ClientUiWireModelOption = {
  key: string
  type: 'select' | 'number' | 'boolean'
  defaultValue?: string
  options: ClientUiWireOptionValue[]
}

export type ClientUiWireAspectOption = {
  value: string
}

export type ClientUiWireImageSizeOption = {
  value: string
  previewWidth: number
  previewHeight: number
}

export type ClientUiWireImageModel = {
  id: string
  platform: string
  sizeOptions?: ClientUiWireImageSizeOption[]
  aspectRatioOptions?: ClientUiWireAspectOption[]
  /** "size" 或 "aspect_ratio"；null 时前端推断 */
  dimensionMode?: string
  extraOptions?: ClientUiWireModelOption[]
  supportsReferenceImages?: boolean
  maxReferenceImages?: number
  nMin?: number
  nMax?: number
}

export type ClientUiWireTextModel = {
  id: string
  platform: string
}

export type ClientUiWirePublic = {
  maxImagesPerRequest: number
  textModels: ClientUiWireTextModel[]
  imageModels: ClientUiWireImageModel[]
  imageSizeOptions: ClientUiWireImageSizeOption[]
  referenceSuperResolutionAvailable?: boolean
}

export type ClientUiOptionValue = {
  value: string
  label: string
  description?: string
}

export type ClientUiModelOption = {
  key: string
  label: string
  type: 'select' | 'number' | 'boolean'
  defaultValue?: string
  options: ClientUiOptionValue[]
}

export type ClientUiImageModel = {
  id: string
  label: string
  description: string
  /** 模型所属平台标识（前端在 normalize 阶段已补全缺省值，与后端 catalog 语义一致） */
  platform: string
  /** 非空时覆盖全局尺寸列表（香蕉等模型） */
  sizeOptions?: ClientUiImageSizeOption[]
  /** 非空时展示宽高比选项（香蕉 aspect_ratio） */
  aspectRatioOptions?: ClientUiAspectOption[]
  /** "size" 或 "aspect_ratio"；决定前端显示哪个控件、API 发哪个参数 */
  dimensionMode: "size" | "aspect_ratio"
  /** 模型支持的额外参数选项（如 quality、background 等） */
  extraOptions?: ClientUiModelOption[]
  /** 是否支持参考图上传 */
  supportsReferenceImages?: boolean
  /** 参考图张数上限 */
  maxReferenceImages?: number
  nMin?: number
  nMax?: number
}

export type ClientUiTextModel = {
  id: string
  label: string
  description: string
  platform: string
}

export type ClientUiAspectOption = {
  value: string
  label: string
}

export type ClientUiImageSizeOption = {
  value: string
  label: string
  description?: string
  previewWidth: number
  previewHeight: number
}

export type ClientUiPublic = {
  maxImagesPerRequest: number
  textModels: ClientUiTextModel[]
  imageModels: ClientUiImageModel[]
  imageSizeOptions: ClientUiImageSizeOption[]
  /** 后端超清策略可用且允许暴露给前端时由 /v1/platform-configs 下发 */
  referenceSuperResolutionAvailable?: boolean
}

export type PlatformConfigBundle = {
  ai: {
    platforms: Record<
      string,
      { enabled: boolean; baseUrl: string; defaultModel: string; apiKeyConfigured: boolean }
    >
  }
  clientUi: ClientUiWirePublic
}

/**
 * 聚合配置：AI 平台摘要 + 前端 UI 清单（模型、尺寸等）
 */
export function getPlatformConfig() {
  return apiRequest<PlatformConfigBundle>('/v1/platform-configs', { method: 'GET' })
}
